import { render, staticRenderFns } from "./Subtitles.vue?vue&type=template&id=66f54a6a&scoped=true&lang=pug&"
import script from "./Subtitles.vue?vue&type=script&lang=js&"
export * from "./Subtitles.vue?vue&type=script&lang=js&"
import style0 from "./Subtitles.vue?vue&type=style&index=0&id=66f54a6a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f54a6a",
  null
  
)

export default component.exports